import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import CountryInput from './country-input';

const InputFieldCountry = (props) => {

    // Global props
    const { type, name, value, getInputValue, label, disabled } = props

    // Props for phone
    const { phoneCode } = props

    // Props for country
    const { exclude, useDefault } = props

    /////////////////////////////////////////////////////////////////////////////////////////
    // const initInputValut = value ? value : ""
    const [inputValue, setInputValue] = useState(value)
    useEffect(() => {
        setInputValue(value)
    }, [])

    useEffect(() => {
        getInputValue && getInputValue(name, inputValue)
    }, [inputValue])

    // Country Input ///////////////////////////////////////////////////////////////
    const getCountry = (name, value) => {
        getInputValue(name, value)
    }

    const Country = () => {
        return (
            <CountryInput
                name={name}
                id={name}
                country={phoneCode}
                getCountry={getCountry}
                exclude={exclude}
                value={value}
                label={label}
                useDefault={useDefault}
                disabled={disabled}
            />
        )
    }

    if (type === "country") return Country()

};


InputFieldCountry.propTypes = {
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    value: PropTypes.any,
    phoneCode: PropTypes.any,
    getInputValue: PropTypes.func,
};

InputFieldCountry.defaultProps = {
    type: "text",
    error: []
}

export default InputFieldCountry
